export const SET_MENU_HISTORY = 'SET_MENU_HISTORY';
